import React, { useEffect, useState } from "react";
import CustomModalV1 from "components/custom-modal/CustomModalV1";
import Button from "components/button/Button";
import {
  XIconV1,
  ArrowDownIconV1,
  ArrowUpIconV1,
  QrCodeIconV1,
} from "images/image-component";
import { useSelector } from "react-redux";
import {
  cardNumberSelector,
  merchantNameByAddressSelector,
  networkTypeSelector,
} from "store/userSliceHelpers";
import { txExplorerUrl } from "utils/network";
import formatDate, { formatTime } from "utils/DateUtil";
import "./transaction-detail-modal.css";
import CardNumber from "components/card-number/CardNumber";
import QrModal from "modals/qr-modal/QrModal";
import { useDispatch } from "react-redux";
import { fetchMerchantName } from "store/merchantNameThunks";
import { AppDispatch } from "store/store";
import { Skeleton } from "components/skeleton";

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  transaction: any;
  tokenSymbol: string;
}

function TransactionDetailModal({
  isOpen,
  handleClose,
  transaction,
  tokenSymbol,
}: Props) {
  const cardNumber = useSelector(cardNumberSelector);
  const networkType = useSelector(networkTypeSelector);
  const [showTxIdQr, setShowTxIdQr] = useState(false);
  const [loadingMerchantName, setLoadingMerchantName] = useState(false);
  const isIn = transaction?.dir === "in";
  const date = new Date(Number(transaction?.time) * 1000);
  const txExplorer = txExplorerUrl(networkType, transaction?.hash);
  const dispatch = useDispatch<AppDispatch>();
  const merchantName = useSelector(
    merchantNameByAddressSelector(transaction?.to),
  );
  console.log(`TransactionDetailModal tx: `, transaction);
  useEffect(() => {
    if (!isOpen || isIn || !transaction.to) return;
    setLoadingMerchantName(true);
    dispatch(fetchMerchantName(transaction.to)).finally(() =>
      setLoadingMerchantName(false),
    );
  }, [isOpen, isIn, merchantName, transaction.to, dispatch]);

  return (
    <CustomModalV1 isOpen={isOpen} handleClose={handleClose}>
      <button
        className="v1-modal-close"
        onClick={handleClose}
        aria-label="Close"
      >
        <XIconV1 />
      </button>

      <div className="v1-tx-detail">
        <div className="v1-tx-detail-header">
          <div className={`v1-tx-detail-dir-icon ${isIn ? "in" : "out"}`}>
            {isIn ? <ArrowDownIconV1 size={18} /> : <ArrowUpIconV1 size={18} />}
          </div>
          <div className="v1-tx-detail-heading">
            <h3 className="v1-tx-detail-title">{isIn ? "Received" : "Sent"}</h3>
            <span className="v1-tx-detail-date">
              {formatDate(date)} · {formatTime(date)}
            </span>
          </div>
        </div>

        <div className="v1-tx-detail-amount-row">
          <span className={`v1-tx-detail-amount-value ${isIn ? "in" : "out"}`}>
            {isIn ? "+" : "−"}
            {transaction?.value.toFixed(2)}
          </span>
          <span className="v1-tx-detail-amount-unit">{tokenSymbol}</span>
        </div>

        <div className="v1-tx-detail-rows">
          {isIn && (
            <div className="v1-tx-detail-row">
              <span className="v1-tx-detail-row-label">Card Number</span>
              <span className="v1-tx-detail-row-value">
                <CardNumber value={cardNumber ?? ""} />
              </span>
            </div>
          )}
          {!isIn && (
            <div className="v1-tx-detail-row">
              <span className="v1-tx-detail-row-label">To</span>
              <span className="v1-tx-detail-row-value">
                {loadingMerchantName ? (
                  <Skeleton width={110} height={16} />
                ) : (
                  merchantName
                )}
              </span>
            </div>
          )}
          {transaction?.blockHeight != null && (
            <div className="v1-tx-detail-row">
              <span className="v1-tx-detail-row-label">Transaction Ref</span>
              <span className="v1-tx-detail-row-value">
                {transaction.blockHeight}
              </span>
            </div>
          )}
          <div className="v1-tx-detail-row">
            <span className="v1-tx-detail-row-label">Transaction ID</span>
            <div className="v1-tx-detail-row-value-row">
              <span className="v1-tx-detail-row-value">
                {transaction?.txId}
              </span>
              {transaction?.txId && (
                <button
                  type="button"
                  className="v1-tx-detail-qr-btn"
                  aria-label="Show transaction ID QR code"
                  onClick={() => setShowTxIdQr(true)}
                >
                  <QrCodeIconV1 size={14} />
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="v1-tx-detail-status">{transaction?.status}</div>

        <Button
          onClick={() => {
            window.open(txExplorer, "_blank");
          }}
          className="v1-auth-submit"
        >
          View in Explorer
        </Button>
      </div>

      {showTxIdQr && (
        <QrModal
          isOpen={showTxIdQr}
          data={transaction?.txId ?? ""}
          close={() => setShowTxIdQr(false)}
          title="Transaction ID"
          warning={null}
        />
      )}
    </CustomModalV1>
  );
}

export default TransactionDetailModal;
